module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inbox-body"
  }, [_c('div', {
    staticClass: "inbox-header"
  }, [_c('h1', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Enviadas")])]), _vm._v(" "), _c('div', {
    staticClass: "inbox-content"
  }, [_c('filter-inbox', {
    attrs: {
      "context": 'sent'
    }
  }), _vm._v(" "), _c('list')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-459be3eb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/inbox/message-send/message-send.vue
// module id = 1061
// module chunks = 1